import { render, staticRenderFns } from "./AtendimentosNaEsb.vue?vue&type=template&id=c6a33316"
import script from "./AtendimentosNaEsb.vue?vue&type=script&lang=js"
export * from "./AtendimentosNaEsb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports